//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable'
import AudioElement from 'components/AudioElement'
import Scrollable from 'components/Scrollable'
import AudioEqualizer from 'components/AudioEqualizer'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { formatSeconds } from 'src/utils'
import debounce from 'quasar/src/utils/debounce.js';

export default {
  name: 'AudioPlayer',

  components: {
    draggable,
    AudioElement,
    Scrollable,
    AudioEqualizer,
  },

  data () {
    return {
      showCurrentPlayList: false,
      editCurrentPlayList: false,
      queueCopy: [],
      hideSeekButton: false,
      isAndroid: navigator.userAgent.toLowerCase().indexOf('android') > -1,
      histroyCheckIntervalId: -1,
      latestUpdatedHistory: null, // 记录最近一次更新的历史记录，防止反复对同一个播放历史进行远程数据更新

      isFlipCover: false, // 是否反转封面显示其他内容

      // 歌词偏移量修复工具
      lyricSyncDialog: false,
      fixState: "ready",  // ready: 准备开始, measure: 计时进行中, done: 计时完成
      fixWhoStartFirst: "", // "audio", "lyric" // 先看到的歌词，还是先听到的声音
      fixStartMills: 0,
      fixStopMills: 0,
    }
  },

  mounted () {
    if (this.$q.localStorage.has('hideSeekButton')) {
      this.hideSeekButton = this.$q.localStorage.getItem('hideSeekButton')
    }
    this.histroyCheckIntervalId = setInterval(() => {
      this.onUpdatePlayingStatus()
    }, 60 * 1000) // 每隔一段时间更新一次播放记录

    if (this.$q.platform.is.desktop) {
      window.addEventListener('keydown', this.onKeyDown);
    }
  },

  beforeDestroy() {
    if (this.$q.platform.is.desktop) {
      window.removeEventListener('keydown', this.onKeyDown);
    }
    clearInterval(this.histroyCheckIntervalId)

    // 原本是想要在关闭窗口时，更新最后一次播放历史
    // 但是实际测试下来，关闭窗口时根本没有来得及发送最后一次更新消息，于是放弃这个方案
    // this.onUpdatePlayingStatus()
  },

  watch: {
    queue (val) {
      this.queueCopy = val.concat()
      // 在删除最后一个 track 时关闭当前播放列表
      if (this.queueCopy.length === 0) {
        this.showCurrentPlayList = false
      } else {
        // 播放列表发生变化，且更新后不为空的情况下
        // 更新播放历史
        this.onUpdatePlayingStatus()
      }
    },

    queueIndex() {
      // 当前播放序号发生变化时更新历史
      this.onUpdatePlayingStatus()
    },

    showCurrentPlayList (flag) {
      // 关闭当前播放列表后，重置 editCurrentPlayList 状态为 false
      if (flag === false) {
        this.editCurrentPlayList = false
      }
    },

    hideSeekButton (option) {
      this.$q.localStorage.set('hideSeekButton', option)
    },

    playing() {
      this.onUpdatePlayingStatus()
    },

    // 监听 前进、后退 进度条时间，
    // 当 ***SeekMode 变为false，表明进度条跳转已经完成
    rewindSeekMode(v) {
      if (!v) {
        // 当用户前进后退时，currentTime可能并没有立即从audio元素中反馈到vue状态里，
        // 因此这里需要延迟一小会，等待audio前进后退之后的更新时间抵达vue的currentTime状态，
        // 然后再去更新播放历史
        setTimeout(() => {
          this.onUpdatePlayingStatus()
        }, 100) 
      }
    },
    forwardSeekMode(v) {
      if (!v) {
        // 当用户前进后退时，currentTime可能并没有立即从audio元素中反馈到vue状态里，
        // 因此这里需要延迟一小会，等待audio前进后退之后的更新时间抵达vue的currentTime状态，
        // 然后再去更新播放历史
        setTimeout(() => {
          this.onUpdatePlayingStatus()
        }, 100)
      }
    },
    currentTime() {
      if (!this.playing) {
        // 暂停状态下切换时间，也更新播放历史
        this.onUpdatePlayingStatus()
      }
    },
    enableVisualizer() {
      this.suggestRefreshPage();
    },
    enableVideoSource() {
      this.suggestRefreshPage();
    },
    lyricSyncDialog() {
      this.fixState = 'ready';
    }
  },

  computed: {
    showAudioPlayer () {
      return this.currentPlayingFile.hash && !this.hide;
    },

    coverUrl () {
      // 从 LocalStorage 中读取 token
      const token = this.$q.localStorage.getItem('jwt-token') || ''
      const hash = this.currentPlayingFile.hash
      let prefix = '/api'
      if (hash.slice(1,2) == ['j']) prefix = `/api/fake`;
      return hash ? `${prefix}/cover/${hash.split('/')[0]}?token=${token}` : ""
    },

    workDetailUrl () {
      const hash = this.currentPlayingFile.hash
      return hash ? `/work/${hash.split('/')[0]}` : ""
    },

    volume: {
      get () {
        return this.$store.state.AudioPlayer.volume
      },
      set (val) {
        this.SET_VOLUME(val)
      }
    },

    queue: {
      get () {
        return this.$store.state.AudioPlayer.queue
      },
      set () {}
    },

    playModeIcon () {
      switch (this.playMode.name) {
        case "all repeat":
          return "repeat"
        case "repeat once":
          return "repeat_one"
        case "shuffle":
          return "shuffle"
        default:
          return "playlist_play"
      }
    },

    playModeString () {
      switch (this.playMode.name) {
        case "all repeat":
          return "全部"
        case "repeat once":
          return "单曲循环"
        case "shuffle":
          return "随机"
        default:
          return "列表播放"
      }
    },

    playingIcon () {
      return this.playing ? "pause" : "play_arrow"
    },

    rewindIcon () {
      switch (this.rewindSeekTime) {
        case 5:
          return 'replay_5'
        case 10:
          return 'replay_10'
        case 30:
          return 'replay_30'
        default:
          return 'replay_5'
      }
    },

    forwardIcon () {
      switch (this.forwardSeekTime) {
        case 5:
          return 'forward_5'
        case 10:
          return 'forward_10'
        case 30:
          return 'forward_30'
        default:
          return 'forward_5'
      }
    },

    fixDeltaMills() {
      // 音频先出现的话，需要将offset增加，使得歌词提前出现
      let sign = this.fixWhoStartFirst == 'audio' ? +1 : -1;
      return sign * (this.fixStopMills - this.fixStartMills);
    },
    showDeltaSeconds() {
      const epsilon = 1;
      if (Math.abs(this.fixDeltaMills) < epsilon) return ""
      return `${this.fixDeltaMills > 0 ? '+': ''}${(this.fixDeltaMills/1000).toFixed(2)}s`;
    },

    ...mapState('AudioPlayer', [
      'playing',
      'hide',
      'currentTime',
      'duration',
      'queueIndex',
      'playMode',
      'rewindSeekTime',
      'forwardSeekTime',
      'swapSeekButton',
      'enableVisualizer',
      'enableVideoSource',
      'enableVideoSourcePIP',
      'enablePIPLyrics',
      'playWorkId',
      'rewindSeekMode',
      'forwardSeekMode',
      'hasLyric',
      'lyricOffsetSeconds',
    ]),
    
    ...mapGetters('AudioPlayer', [
      'currentPlayingFile',
      'resumeHistroyDone',
      'isCurrentPlayingFileVideo',
    ])
  },

  methods: {
    formatSeconds,

    startFixLyricSync(whoStartFirst) {
      this.fixState = "measure";
      this.fixWhoStartFirst = whoStartFirst;
      this.fixStartMills = this.fixStopMills = performance.now();
    },

    stopFixLyricSync() {
      this.fixState = "done"; // 计时结束，重制状态
      this.fixStopMills = performance.now();
    },

    fixApply() {
      this.lyricOffsetChange(this.fixDeltaMills / 1000);
      this.lyricSyncDialog = false;
      this.fixState = "ready";
      this.$q.notify({message: `歌词偏移量(${this.fixDeltaMills/1000}s)已应用`, timeout: 500})
    },

    ...mapMutations('AudioPlayer', {
      toggleHide: 'TOGGLE_HIDE',
      togglePlaying: 'TOGGLE_PLAYING',
      nextTrack: 'NEXT_TRACK',
      previousTrack: 'PREVIOUS_TRACK',
      changePlayMode: 'CHANGE_PLAY_MODE',
      setVolume: 'SET_VOLUME',
      rewind: 'SET_REWIND_SEEK_MODE',
      forward: 'SET_FORWARD_SEEK_MODE',
      toggleSwapSeekButton: 'TOGGLE_SWAP_SEEK_BUTTON',
      toggleEnableVisualizer: 'TOGGLE_ENABLE_VISUALIZER',
      toggleEnableVideoSource: 'TOGGLE_ENABLE_VIDEO_SOURCE',
      setEnableVideoSourcePIP: 'SET_ENABLE_VIDEO_SOURCE_PIP',
      setEnablePIPLyrics: 'SET_ENABLE_PIP_LYRICS',
      setLyricOffsetSeconds: 'SET_LYRIC_OFFSET_SECONDS',
    }),
    ...mapMutations('AudioPlayer', [
      'SET_TRACK',
      'SET_QUEUE',
      'REMOVE_FROM_QUEUE',
      'EMPTY_QUEUE',
      'SET_VOLUME',
    ]),

    samCoverUrl (hash) {
      // 从 LocalStorage 中读取 token
      const token = this.$q.localStorage.getItem('jwt-token') || ''
      let prefix = '/api'
      if (hash.slice(1,2) == ['j']) prefix = `/api/fake`;
      return hash ? `${prefix}/cover/${hash.split('/')[0]}?type=sam&token=${token}` : ""
    },

    onClickTrack (index) {
      if (!this.editCurrentPlayList) {
        this.SET_TRACK(index)
        this.showCurrentPlayList = false
      }
    },

    onMoved(moved) {
      let index = null
      if (moved.oldIndex === this.queueIndex) {
        index = moved.newIndex
      } else if (moved.oldIndex < this.queueIndex && moved.newIndex >= this.queueIndex) {
        index = this.queueIndex - 1
      } else if (moved.oldIndex > this.queueIndex && moved.newIndex <= this.queueIndex) {
        index = this.queueIndex + 1
      } else {
        index = this.queueIndex
      }
   
      this.SET_QUEUE({
        queue: this.queueCopy.concat(),
        index: index,
        resetPlaying: false
      })
    },

    removeFromQueue (index) {
      this.REMOVE_FROM_QUEUE(index)
    },

    emptyQueue () {
      this.EMPTY_QUEUE()
    },

    onCoverSwipe(evt) {
      switch(evt.direction) {
        case 'left':
        case 'right':
          this.flipCover();
          break;
        case 'down':
          this.toggleHide();
      }
    },

    openWorkDetail () {
      if (this.workDetailUrl && this.$route.path !== this.workDetailUrl) {
        this.$router.push(this.workDetailUrl)
      }
      if (this.$q.screen.lt.sm) {
          this.toggleHide()
      }
    },

    setPIPLyrics() {
      if (!this.enablePIPLyrics) {
        this.$q.notify({message: "创建桌面歌词组件中，请稍等...", timeout: 500})
      }
      this.setEnablePIPLyrics(!this.enablePIPLyrics)
    },
    
    // return true if two history updated on (onUpdatePlayingStatus) is same
    isSameTwoHistory(ha, hb) {
      // 如果有任意一个是null，则认为两者不一样
      if (!(ha && hb)) return false;
      
      if (ha.work_id != hb.work_id) return false;
      if (ha.state.seconds != hb.state.seconds) return false;
      if (ha.state.index != hb.state.index) return false;
      if (ha.state.queue.length != hb.state.queue.length) return false;
      for (let i = 0; i < ha.state.queue.length; ++i) {
        if (ha.state.queue[i].hash != hb.state.queue[i].hash) return false;
      }
      return true;
    },
    
    onUpdatePlayingStatus() {
      // 当前播放列表为空，禁止记录播放历史
      if (this.queueCopy.length <= 0) return;

      // 尚处于恢复历史记录的阶段，为了避免此时将空状态写入远程服务器覆盖有效状态，跳过本次历史更新
      if (!this.resumeHistroyDone) {
        console.log("尚处于恢复历史记录的状态，跳过本次历史更新")
        return
      }

      const data = {
        "work_id": this.playWorkId,
        "state": {
          queue: this.queueCopy,
          index: this.queueIndex,
          seconds: this.currentTime,
        }
      }

      // 检查最近一次的历史更新记录，如果两次数据不变，则无需更新记录
      if (this.isSameTwoHistory(this.latestUpdatedHistory, data)) {
        console.log("播放状态未变，跳过服务器历史更新")
        return
      }

      this.$axios.put('/api/histroy', data)
        .then((_) => {
          console.log("更新播放状态成功")
          this.latestUpdatedHistory = data;
        })
        .catch((err) => {
          console.error(err.response.data.error)
        })
    },

    // 中转一道这个设置，加一些用户提示
    onToggleVideoSource() {

      // 如果是关闭的话，直接关掉，无需用户提示
      if (this.enableVideoSource) {
        this.toggleEnableVideoSource();
        return;
      }

      // 打开的话，需要提示一些用户信息
      this.$q.dialog({
        title: '注意',
        message: '开启视频源绘制功能会增加性能开销，移动设备上可能会发热严重，请谨慎选择。此外，在iOS safari系统中，safari会强制将页面中正在播放的视频元素设置为画中画模式，无法规避，建议iOS safari环境下关闭此项功能',
        cancel: true,
      }).onOk(() => {
        this.toggleEnableVideoSource()
      }).onCancel(() => {})
    },

    onSetEnableVideoSourcePIP(enable) {
      this.setEnableVideoSourcePIP(enable)

      const video = document.querySelector("#mediaVideo") // 全局id获取对应的video元素，因为safari进入pip模式需要在用户动作回调中执行，实在是没法跨组件做这个，这里hack一下
      const isAlreadyInPIP = document.pictureInPictureElement === video
      if (enable && !isAlreadyInPIP) {
        if (
          typeof video.requestPictureInPicture === 'function' &&
          document.pictureInPictureEnabled
        ) {
          video.requestPictureInPicture().then(() => {
            video.addEventListener('leavepictureinpicture', () => {
              if (this.playing) this.player.play()
              this.setEnableVideoSourcePIP(false)
            })
          }).catch((err) => {
            console.log("PIP in video source failed, msg = ", err.message)
          })
        } else if (typeof video.webkitPresentationMode === 'function') {
          video.webkitPresentationMode('picture-in-picture')
        }
      } else if (isAlreadyInPIP) {
        document.exitPictureInPicture();
      }
    },

    gotoFullScreenPlayer() {
      this.$router.push(`/fullScreenPlayer`)
    },

    // 当发生特定配置改动，需要用户刷新页面时，通过这个通知来提示用户
    suggestRefreshPage() {
      this.$q.notify({
        message: "配置已更改，建议刷新页面",
        actions: [
          { label: "立即刷新",
            handler: () => {
              // this.$router.push(`/fullScreenPlayer/${this.playWorkId}`)
              // this.$router.push(`/fullScreenPlayer`)
              this.$router.go(0);
            }
          }
        ],
      });
    },

    lyricOffsetChange(seconds) {
      if (seconds == null) seconds = 0;
      seconds = Math.round(seconds * 10000) / 10000; // 解决javascript小数点精度问题，比如0.9+0.1变成0.999999这种问题，在这里修复成1.0
      console.log("lyric offset change to ", seconds, typeof seconds)
      this.setLyricOffsetSeconds(seconds)
    },

    flipCover() {
      if (!this.enableVisualizer) return; // 尚未开启音频可视化选项，无法使用音效均衡器
      console.warn("flip cover");
      this.isFlipCover = !this.isFlipCover;
    },

    onKeyDown(event) {
      // console.warn("key down code = ", event.code, ", activeElement is ", document.activeElement); 
      if (document.activeElement.tagName === "INPUT") return; // 禁止文本编辑的按键响应
      if (this.playWorkId === 0) return; // 尚未播放任何作品时，禁止快捷键操作
      const volumeStep = 0.04; // volume is between [0.0, 1.0]

      switch(event.code) {
        case "Space": this.togglePlaying(); break;
        case "ArrowLeft": this.rewind(true); break;
        case "ArrowRight": this.forward(true); break;

        case "PageDown": this.nextTrack(); break;
        case "PageUp": this.previousTrack(); break;

        case "ArrowUp": 
          this.volume = Math.min(1.0, this.volume + volumeStep); break;
        case "ArrowDown": 
          this.volume = Math.max(0.0, this.volume - volumeStep); break;
        default: return; // return now
      }

      event.preventDefault()
      event.stopPropagation()
    },
  },

  created() {
    // 历史更新函数防抖动
    this.onUpdatePlayingStatus = debounce(this.onUpdatePlayingStatus, 500);
  }
}
